import React, { useState } from "react";
import { TextField, Grid, Button, Link } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useSession } from "../../lib/hooks";
import { LanguageItem, AuthPageLayout } from "../../lib/common";
import AsyncFormBox from "../../lib/common/AsyncFormBox";
import { UsernameInput } from "../../lib/inputs";

function TranslatedLoginError({ error }) {
  const errorCode = error?.code;
  const causeName = error?.params?.cause?.name;

  if (
    errorCode === "glint-js/loginFailed" &&
    (causeName === "IncorrectUsernameError" || causeName === "IncorrectPasswordError")
  ) {
    return (
      <React.Fragment>
        <LanguageItem cs>Špatné jméno nebo heslo.</LanguageItem>
        {/* <LanguageItem en>Invalid username or password.</LanguageItem> */}
      </React.Fragment>
    );
  } else if (errorCode === "glint-js/userNotVerified") {
    return (
      <React.Fragment>
        <LanguageItem cs>Váš e-mail nebyl ověřen. Klikněte na odkaz v e-mailu pro ověření.</LanguageItem>
        {/* <LanguageItem en>Invalid username or password.</LanguageItem> */}
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <LanguageItem cs>Kontaktujte správce aplikace.</LanguageItem>
        {/* <LanguageItem en>Contact administrator of the application.</LanguageItem> */}
      </React.Fragment>
    );
  }
}

function SignIn() {
  const session = useSession();
  const navigate = useNavigate();
  const [userError, setUserError] = useState();

  function handleSubmit(values) {
    return session.login(values.email, values.password);
  }

  // Session is a bit different -> feedback can be positive, so we need to distinguish between errors here from response
  function onSubmitDone(result) {
    if (result instanceof Error) {
      setUserError({
        title: (
          <React.Fragment>
            <LanguageItem cs>Přihlášení se nezdařilo</LanguageItem>
            {/* <LanguageItem en>Sign In has failed</LanguageItem> */}
          </React.Fragment>
        ),
        message: <TranslatedLoginError error={result?.response?.data} />,
      });
    } else {
      navigate("/");
    }
  }

  return (
    <AuthPageLayout
      title={
        <>
          <LanguageItem cs>Přihlášení</LanguageItem>
          {/* <LanguageItem en>Sign In</LanguageItem> */}
        </>
      }>
      <AsyncFormBox
        onSubmit={handleSubmit}
        onSubmitDone={onSubmitDone}
        boxProps={{
          sx: { mt: 2 },
        }}
        userError={userError}>
        <UsernameInput margin={"normal"} fullWidth autoFocus />

        <TextField
          margin={"normal"}
          required
          fullWidth
          name={"password"}
          label={
            <>
              <LanguageItem cs>Heslo</LanguageItem>
              {/* <LanguageItem en>Password</LanguageItem> */}
            </>
          }
          type={"password"}
          autoComplete={"current-password"}
        />

        {/* there is no backend support for this yet */}
        {/* <FormControlLabel */}
        {/*   control={<Checkbox value={'remember'} color={'primary'} />} */}
        {/*   label={'Remember me'} */}
        {/* /> */}

        <Button type={"submit"} fullWidth variant={"contained"} sx={{ mt: 3, mb: 2 }}>
          <LanguageItem cs>Přihlásit</LanguageItem>
          {/* <LanguageItem en>Sign In</LanguageItem> */}
        </Button>

        <Grid container>
          <Grid size="grow">
            <Link component={RouterLink} to={"/forgotPassword"} variant={"body2"}>
              <LanguageItem cs>Zapomenuté heslo?</LanguageItem>
              {/* <LanguageItem en>Forgot password?</LanguageItem> */}
            </Link>
          </Grid>
          <Grid>
            <Link component={RouterLink} to={"/signUp"} variant={"body2"}>
              <LanguageItem cs>Nemáte ještě účet? Zaregistrujte se</LanguageItem>
              {/* <LanguageItem en>Don&apos;t have an account? Sign Up</LanguageItem> */}
            </Link>
          </Grid>
        </Grid>
      </AsyncFormBox>
    </AuthPageLayout>
  );
}

export default SignIn;
